import { Reveal } from "./Reveal";
import { MapPin, Clock3, Phone, Mail, Instagram, Facebook } from "lucide-react";

export default function InfoFooter({ content }) {
  const c = content || {};
  return (
    <footer id="contact" data-testid="info-footer" className="bg-[#FBF8F3]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 md:py-24">
        <Reveal className="mb-14">
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-[#C85A32] mb-4">Accès & infos pratiques</p>
          <h2 className="font-display tracking-tight text-[#201815] text-3xl sm:text-4xl lg:text-5xl leading-tight">
            On se retrouve <span className="italic text-[#C85A32]">à Auch.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-16">
          <Reveal>
            <div className="rounded-2xl border border-[#E5DCD3] bg-white p-7 h-full">
              <MapPin size={22} className="text-[#C85A32] mb-5" />
              <h3 className="font-display text-xl text-[#201815] mb-2">Adresse</h3>
              <p data-testid="footer-address" className="text-sm text-[#5C4E48] leading-relaxed">{c.address || "12 rue de la République, 32000 Auch"}</p>
              <p className="text-xs text-[#8A7971] mt-3">Parkings à proximité : parking du Tribunal, parking de l'ancien Foirail et parking couvert.</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-2xl border border-[#E5DCD3] bg-white p-7 h-full">
              <Clock3 size={22} className="text-[#C85A32] mb-5" />
              <h3 className="font-display text-xl text-[#201815] mb-2">Horaires</h3>
              <p data-testid="footer-hours" className="text-sm text-[#5C4E48] leading-relaxed">{c.hours || "Mardi – Samedi : 9h30 – 19h00"}</p>
              <p className="text-xs text-[#8A7971] mt-3">{c.hours_note || "Ouvert du lundi au samedi. Créneaux ateliers : 10h, 13h15 et 16h."}</p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="rounded-2xl border border-[#E5DCD3] bg-white p-7 h-full">
              <Phone size={22} className="text-[#C85A32] mb-5" />
              <h3 className="font-display text-xl text-[#201815] mb-2">Contact</h3>
              <p data-testid="footer-phone" className="text-sm text-[#5C4E48]">{c.phone || "05 62 00 00 00"}</p>
              <p className="text-sm text-[#5C4E48] mt-1 flex items-center gap-2"><Mail size={13} className="text-[#8A7971]" />{c.email_contact || "bonjour@argileetcafe.fr"}</p>
              {(c.instagram_url || c.facebook_url) && (
                <div className="flex gap-3 mt-4">
                  {c.instagram_url && (
                    <a href={c.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="social-instagram" aria-label="Instagram" className="h-9 w-9 rounded-full border border-[#E5DCD3] flex items-center justify-center text-[#5C4E48] hover:border-[#C85A32] hover:text-[#C85A32] transition-colors">
                      <Instagram size={15} />
                    </a>
                  )}
                  {c.facebook_url && (
                    <a href={c.facebook_url} target="_blank" rel="noopener noreferrer" data-testid="social-facebook" aria-label="Facebook" className="h-9 w-9 rounded-full border border-[#E5DCD3] flex items-center justify-center text-[#5C4E48] hover:border-[#C85A32] hover:text-[#C85A32] transition-colors">
                      <Facebook size={15} />
                    </a>
                  )}
                </div>
              )}
            </div>
          </Reveal>
        </div>

        <Reveal>
          <div className="rounded-2xl bg-[#F4EFEA] border border-[#E5DCD3] p-7 md:p-9">
            <p className="text-xs uppercase tracking-[0.25em] text-[#8A7971] mb-3">Café céramique à Auch, dans le Gers</p>
            <p className="text-sm text-[#5C4E48] leading-relaxed max-w-4xl">
              {c.brand_name || "L'Argile & Café"} est le premier café céramique d'Auch (32000). Atelier de peinture sur céramique de 2h15
              pour tous : sortie en famille, moment entre amis, anniversaire, EVJF dans le Gers ou team building. Réservez votre créneau
              en ligne — 14 places maximum par session — et savourez un café de spécialité pendant que vous créez. Cartes cadeaux et
              abonnements disponibles au comptoir et en ligne.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="border-t border-[#E5DCD3]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-7 flex flex-wrap items-center justify-between gap-4">
          <p className="text-xs text-[#8A7971]">© 2026 {c.brand_name || "L'Argile & Café"} — Café céramique, Auch.</p>
          <div className="flex items-center gap-6 text-xs text-[#8A7971]">
            <a href="/annulation" data-testid="footer-cancel" className="hover:text-[#C85A32] transition-colors">Annuler une réservation</a>
            <a href="/mentions-legales" data-testid="footer-legal" className="hover:text-[#C85A32] transition-colors">Mentions légales</a>
            <a href="/reglement-interieur" data-testid="footer-reglement" className="hover:text-[#C85A32] transition-colors">Règlement intérieur</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
